import { render, staticRenderFns } from "./orderSend.vue?vue&type=template&id=6aa62d4e&scoped=true"
import script from "./orderSend.vue?vue&type=script&lang=js"
export * from "./orderSend.vue?vue&type=script&lang=js"
import style0 from "./orderSend.vue?vue&type=style&index=0&id=6aa62d4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa62d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa62d4e')) {
      api.createRecord('6aa62d4e', component.options)
    } else {
      api.reload('6aa62d4e', component.options)
    }
    module.hot.accept("./orderSend.vue?vue&type=template&id=6aa62d4e&scoped=true", function () {
      api.rerender('6aa62d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/lists/orderSend.vue"
export default component.exports